var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',_vm._g(_vm._b({class:{'eod-expansion-panels-no-inset': _vm.noInset, 'eod-expansion-panels-no-border': _vm.noBorder},attrs:{"flat":""}},'v-expansion-panels',{..._vm.$attrs, ..._vm.$props},false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }